import { UnicodeEntity } from '@mews/enums';

export const MqlWordSeparator = UnicodeEntity.Space;
export const MqlTriggerCharacter = UnicodeEntity.ForwardSlash;
